module.exports = __webpack_public_path__ + "media/images/tour/en-5055aadb9c172b68f6ec5fcc12b9bcd1.png";